import * as workflowEngineStore from './store'

// Registra o módulo Vuex `workflowEngine` (namespaced). Espelha o padrão dos
// demais módulos (crm/compliance) — idempotente via hasModule.
export function workflowEngineModule({ store }) {
  if (
    typeof store.hasModule === 'function' &&
    store.hasModule('workflowEngine')
  ) {
    return
  }

  store.registerModule('workflowEngine', {
    ...workflowEngineStore,
    namespaced: true,
  })
}
